import { Component, Inject, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { StepTypes } from '../../../model/enums/step-types';
import { UDeuStep } from '../../../model/classes/udeu-step';
import { MatFormFieldType } from '../../../model/enums/mat-form-field-types';
import { UdeuService } from '../../../services/udeu.service';
import { BOUD_ACTIONS_DATALIST_NAME,  BOUD_PRIMARY_APPROVING_BODY_DATALIST_NAME, BOUD_SUBTYPES_DATALIST_NAME, BOUD_TYPES_DATALIST_NAME, SUBDIVISION_NOMINAL_FACULTADES_GAUDE_DATALIST_NAME } from '../../../model/contants/datalists';
import { Store } from '@ngrx/store';
import { AppStore, getUserProfile, SnackbarErrorAction, SnackbarWarningAction } from '@alfresco/aca-shared/store';
import { KeyValue } from '@angular/common';
import { Router } from '@angular/router';
import { ReloadCustomListTableAction } from 'projects/alden-extension/src/lib/store/actions/alden.actions';
import { SMTConfirmDialogComponent } from 'projects/alden-extension/src/lib/dialogs/confirm/confirm.dialog';
import { MatStep } from '@angular/material/stepper';
import { BoudActionTypes } from '../../../store/actions/boud-actions';
import { AssocElements, UdeuBoud, UdeuContent, UdeuCreateBoud, UdeuData, UdeuInfo } from '../../../model/classes/udeu-boud';
import { BoudService } from '../../../services/boud.service';
import { ACTION_TYPE_FIELD, APPROVAL_DATE_FIELD, BOUD_RECORD_ID_FIELD, CONTENT_STEP, CORRECTED_ELEMENTS_FIELD, CORRECTORS_ELEMENTS_FIELD, EFFECTIVE_DATE_FIELD, ELEMENTS_STEP, ENGLISH_CONTENT_FIELD, EUSKERA_CONTENT_FIELD, INFO_STEP, MAIN_DATA_STEP, MENTIONED_ELEMENTS_FIELD, MENTIONERS_ELEMENTS_FIELD, MODIFIED_ELEMENTS_FIELD, MODIFIERS_ELEMENTS_FIELD, NOMINAL_SUBDIVISION_FIELD, PRIMARY_APPROVING_BODY_FIELD, PROVISION_NUMBER_FIELD, PUBLICATION_DATE_FIELD, PUBLICATION_USER_FIELD, REPEALED_ELEMENTS_FIELD, REPEALERS_ELEMENTS_FIELD, SPANISH_CONTENT_FIELD, SUBTYPE_FIELD, SUSPENDED_ELEMENTS_FIELD, SUSPENDERS_ELEMENTS_FIELD, TYPE_FIELD,OBSERVATIONS_FIELD, PARTIAL_REPEAL_FIELD } from '../../../model/contants/udeu-boud';
import { UdeuCreateFile, UdeuFile } from '../../../model/classes/udeu-files';
import { AttachedFile } from 'projects/alden-extension/src/lib/models/attached-file';
import { UdeuStatus } from '../../../model/classes/udeu-status';
import { UDEU_BOUD_DRAFT_STATUS, UDEU_BOUD_FACULTY_PRODUCING_KEY, UDEU_BOUD_UD_DISPOSITION_TYPE, UDEU_BOUD_POLICY_TYPES, UDEU_BOUD_READY_STATUS, UDEU_BOUD_VALIDATED_STATUS, UDEU_BOUD_PARTIAL_REPEALING_ACTION } from '../../../model/contants/deusto';
import { MIME_TYPE_WORD_XML } from 'projects/alden-extension/src/lib/models/mime-types';
import { UdeuRecord } from '../../../model/classes/udeu-record';
import { ProfileState } from '@alfresco/adf-extensions';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { canManageBoud } from '../../../rules/boud.rules';
import { ArrayValidators } from 'projects/alden-extension/src/lib/validators/array.validator';
import { SMTLoadingDialogComponent } from 'projects/alden-extension/src/lib/dialogs/loading/loading.dialog';
import { APP_CONFIG_FILE_SIZE_LIMIT } from 'projects/alden-extension/src/lib/models/alden-constants';
import { AldenService } from 'projects/alden-extension/src/lib/services/alden.service';
import { actionTypeEnum } from '../../../model/enums/boud-assoc-element-type';
import { DateType } from 'projects/alden-extension/src/lib/models/date-types';

export interface DialogData {
  boudActionType: BoudActionTypes;
  UUID?: string;
  selectedIndex?: number;
}

@Component({
  templateUrl: './create-boud.dialog.html',
  styleUrls: ['./create-boud.dialog.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CreateBoudDialogComponent implements OnInit {
  loading: boolean;

  private _formBuilder = inject(FormBuilder);

  DateType: typeof DateType = DateType;
  
  steps: { [id: string]: UDeuStep };

  mainFormGroup: FormGroup<any>;
  dataFormGroup: FormGroup<any>;
  infoFormGroup: FormGroup<any>;
  
  elementsFormGroup: FormGroup<any>;

  contentsFormGroup: FormGroup<any>;

  StepTypes: typeof StepTypes = StepTypes;
  MatFormFieldType: typeof MatFormFieldType = MatFormFieldType;
  BoudActionTypes: typeof BoudActionTypes = BoudActionTypes;
  
  elementActionTypes = actionTypeEnum;

  boud: UdeuBoud;
  boudStatus: string;
  boudType: string;
  actionType: string;
  isPolicy: boolean;
  editableContentFields: string[];
  mandatoryContentFields: string[];
  mimeTypes: string[];

  UDEU_BOUD_DRAFT_STATUS: string;

  selectedIndex: number;

  profile$: Observable<ProfileState>;
  isManager: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogData, private dialogRef: MatDialogRef<CreateBoudDialogComponent>, private dialog: MatDialog, 
    public udeuService: UdeuService, private boudService: BoudService, protected store: Store<AppStore>, private router: Router, private aldenService: AldenService) {
      this.UDEU_BOUD_DRAFT_STATUS = UDEU_BOUD_DRAFT_STATUS;
      this.mimeTypes = [MIME_TYPE_WORD_XML];
      this.profile$ = this.store.select(getUserProfile);
  }

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.beforeClosed();
    
    await this.initilizeForms();
    this.createSteps();

    const promises = this.data?.boudActionType !== BoudActionTypes.ViewBoud ? [
      // MAIN_DATA_STEP
      this.udeuService.getMasterList(this.steps, MAIN_DATA_STEP, TYPE_FIELD, BOUD_TYPES_DATALIST_NAME, true),
      this.udeuService.getMasterList(this.steps, MAIN_DATA_STEP, ACTION_TYPE_FIELD, BOUD_ACTIONS_DATALIST_NAME),
    ] : [];


    await Promise.all(promises).then(async () => {
      this.profile$.pipe(
        take(1)
      ).subscribe(async (profile) => {
        this.isManager = canManageBoud(profile);
        this.selectedIndex = this.data?.selectedIndex ? this.data.selectedIndex - (Object.values(this.steps).filter((step, index) => index < this.data.selectedIndex && step.disabled).length) : 0;
        this.loading = false;
      });
    }).catch((err) => { 
      console.error("ERROR", err);
      this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.RESPONSE.500'));
      this.dialogRef.close();
      this.loading = false;
    });
  }

  beforeClosed() {
    // Interceptamos el evento de cerrar el diálogo
    this.dialogRef.backdropClick().subscribe(() => {
      this.closeDialog();
    });

    // Interceptamos el evento de presionar la tecla Esc
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.closeDialog();
      }
    });
  }

  closeDialog() {
    if(this.data?.boudActionType === BoudActionTypes.ViewBoud) {
      this.dialogRef.close();
      return;
    }

    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: {
        title: 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.CLOSE.DIALOG.TITLE',
        message: 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.CLOSE.DIALOG.MESSAGE',
        noLabel: 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.CLOSE.DIALOG.NO_LABEL',
        yesLabel: 'DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.CLOSE.DIALOG.YES_LABEL'
      },
      minWidth: '250px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {       
        this.dialogRef.close();
      }
    });
  }

  async initilizeForms() {
    const UUID = this.data?.UUID;
    if(UUID) {
      await this.boudService.getBoud(UUID).then((res) => { 
        this.boud = res;
        this.boudStatus = (this.boud.status.status as KeyValue<string, string>).key;
        this.updateActionType(this.boud.data?.actionType as KeyValue<string, string>);
        this.updateType(this.boud.data?.type as KeyValue<string, string>);
      });
    }

    this.dataFormGroup = this._formBuilder.group({
      [TYPE_FIELD]: [this.boud?.data?.type, [Validators.required]],
      [SUBTYPE_FIELD]: [this.boud?.data?.subtype],
      [PRIMARY_APPROVING_BODY_FIELD]: [this.boud?.data?.primaryApprovingBody],
      [NOMINAL_SUBDIVISION_FIELD]: [this.boud?.data?.nominalSubdivision],
      //[SECONDARY_APPROVING_BODY_FIELD]: [this.boud?.data?.secondaryApprovingBody],
      //[SECONDARY_APPROVING_BODY_SUB_FIELD]: [this.boud?.data?.secondaryApprovingBodySub],
      [PROVISION_NUMBER_FIELD]: [this.boud?.data?.provisionNumber, [Validators.required]],
      [ACTION_TYPE_FIELD]: [this.boud?.data?.actionType, [Validators.required]],
      [APPROVAL_DATE_FIELD]: [this.boud?.data?.approvalDate],
      [EFFECTIVE_DATE_FIELD]: [this.boud?.data?.effectiveDate],
      [OBSERVATIONS_FIELD]: [this.boud?.data?.observations],
      [PARTIAL_REPEAL_FIELD]: [this.boud?.data?.partialRepeal]
    });

    this.infoFormGroup = this._formBuilder.group({
      [PUBLICATION_DATE_FIELD]: [this.boud?.info?.publicationDate],
      [PUBLICATION_USER_FIELD]: [this.boud?.info?.publicationUser],
      [BOUD_RECORD_ID_FIELD]: [(this.boud?.info?.record as UdeuRecord)?.name],
    });

    this.contentsFormGroup = this._formBuilder.group({
      [SPANISH_CONTENT_FIELD]: [this.boud?.content?.spanishContent, [Validators.required]],
      [EUSKERA_CONTENT_FIELD]: [this.boud?.content?.euskeraContent, [Validators.required]],
      [ENGLISH_CONTENT_FIELD]: [this.boud?.content?.englishContent]
    });

    this.elementsFormGroup = this._formBuilder.group({
      [MENTIONED_ELEMENTS_FIELD]: this._formBuilder.array([]),
      [CORRECTED_ELEMENTS_FIELD]: this._formBuilder.array([]),
      [MODIFIED_ELEMENTS_FIELD]: this._formBuilder.array([]),
      [SUSPENDED_ELEMENTS_FIELD]: this._formBuilder.array([]),
      [REPEALED_ELEMENTS_FIELD]: this._formBuilder.array([]),
      [MENTIONERS_ELEMENTS_FIELD]: this._formBuilder.array([]),
      [MODIFIERS_ELEMENTS_FIELD]: this._formBuilder.array([]),
      [REPEALERS_ELEMENTS_FIELD]: this._formBuilder.array([]),
      [SUSPENDERS_ELEMENTS_FIELD]: this._formBuilder.array([]),
      [CORRECTORS_ELEMENTS_FIELD]: this._formBuilder.array([]),
    });

    this.mainFormGroup = this._formBuilder.group({
      data: this.dataFormGroup,
      info: this.infoFormGroup,
      elements: this.elementsFormGroup,
      contents: this.contentsFormGroup
    });

    if(this.data?.boudActionType === BoudActionTypes.ViewBoud) {
      this.mainFormGroup.disable();
    };
  }

  createSteps() {
    this.steps = {
      [MAIN_DATA_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.MAIN_DATA.TITLE",
        type: StepTypes.GENERIC,
        form: {
          group: this.dataFormGroup,
          fields: {
            [TYPE_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.TYPE",
              changeFunc: [
                (option, reset?) => this.getListAndValidators(MAIN_DATA_STEP, SUBTYPE_FIELD, BOUD_SUBTYPES_DATALIST_NAME, option?.key, reset),
                (option, reset?) =>  {
                  
                  if(UDEU_BOUD_POLICY_TYPES.includes(option?.key)){
                    if(this.data?.boudActionType === BoudActionTypes.ViewBoud)
                      this.getList(MAIN_DATA_STEP, PRIMARY_APPROVING_BODY_FIELD, BOUD_PRIMARY_APPROVING_BODY_DATALIST_NAME, '', reset,false);
                    else
                      this.getActiveProducingBodiesList(MAIN_DATA_STEP,PRIMARY_APPROVING_BODY_FIELD,reset);
                  }
                  else{
                    this.getList(MAIN_DATA_STEP, PRIMARY_APPROVING_BODY_FIELD, BOUD_PRIMARY_APPROVING_BODY_DATALIST_NAME, '', reset,true);
                  } 
                },
                (option, reset?) => this.getList(MAIN_DATA_STEP, ACTION_TYPE_FIELD, BOUD_ACTIONS_DATALIST_NAME, option?.key, reset),
                (option) => this.updateType(option)
              ],
              style: { width: '100%' }
            },
            [SUBTYPE_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SUBTYPE", optional: true,
              //changeFunc: [(option, reset?) => {if(option?.key) this.getList(MAIN_DATA_STEP, PRIMARY_APPROVING_BODY_FIELD, BOUD_PRIMARY_APPROVING_BODY_DATALIST_NAME, '', reset,false)}],
              style: { width: '100%' },
              changeFunc:[
                (option) => this.updateSubtype(option)
              ]
            },
            [PRIMARY_APPROVING_BODY_FIELD]: {
              type: MatFormFieldType.SELECT_MULTIPLE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.PRIMARY_APPROVING_BODY", optional: true,
              changeMultFunc: [
                (option,reset?) =>{  
                    if(option?.some((opt) => opt.key === UDEU_BOUD_FACULTY_PRODUCING_KEY)) this.getGaudeList(MAIN_DATA_STEP, NOMINAL_SUBDIVISION_FIELD, SUBDIVISION_NOMINAL_FACULTADES_GAUDE_DATALIST_NAME,reset)
                      else this.getGaudeList(MAIN_DATA_STEP, NOMINAL_SUBDIVISION_FIELD, '',reset)
                  }
               // (option, reset?) => this.getListAndValidators(MAIN_DATA_STEP, SECONDARY_APPROVING_BODY_FIELD, BOUD_SECONDARY_APPROVING_BODY_DATALIST_NAME, option?.key, reset)
              ],
              style: { width: '100%' }
            },
            [NOMINAL_SUBDIVISION_FIELD]: {
              type: MatFormFieldType.SELECT_MULTIPLE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.NOMINAL_SUBDIVISION_BOUD", optional: true,
              style: { width: '100%' }
            },
         /*   [SECONDARY_APPROVING_BODY_FIELD]: {
              type: MatFormFieldType.SELECT_MULTIPLE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SECONDARY_APPROVING_BODY", optional: true,
              changeMultFunc: [(option, reset?) => this.getListAndValidators(MAIN_DATA_STEP, SECONDARY_APPROVING_BODY_SUB_FIELD, BOUD_SECONDARY_APPROVING_BODY_SUB_DATALIST_NAME, option?.map((opt) => opt.key).join(','), reset)],
              style: { width: '100%' }
            },
            [SECONDARY_APPROVING_BODY_SUB_FIELD]: {
              type: MatFormFieldType.SELECT_MULTIPLE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.SECONDARY_APPROVING_BODY_SUB", optional: true, 
              style: { width: '100%' }
            },*/
            [PROVISION_NUMBER_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.PROVISION_NUMBER"
            },
            [ACTION_TYPE_FIELD]: {
              type: MatFormFieldType.SELECT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.ACTION_TYPE",
              changeFunc: [(option) => this.updateActionType(option)],
            },
            [APPROVAL_DATE_FIELD]: {
              type: MatFormFieldType.DATE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.APPROVAL_DATE"
            },
            [EFFECTIVE_DATE_FIELD]: {
              type: MatFormFieldType.DATE, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.EFFECTIVE_DATE",
              disabled: this.boudType && !this.isPolicy
            },
            [OBSERVATIONS_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.OBSERVATIONS"
            },
            [PARTIAL_REPEAL_FIELD]: {
              type: MatFormFieldType.INPUT, label: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.FIELDS.MAIN_DATA.PARTIAL_REPEAL",optional:true, disabled: this.actionType !== UDEU_BOUD_PARTIAL_REPEALING_ACTION,
              style: {width: '100%'}
            }
          }
        }
      },
      [INFO_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.INFO.TITLE",
        type: StepTypes.BOUD,
        disabled: !this.boudStatus || this.boudStatus === UDEU_BOUD_DRAFT_STATUS || this.boudStatus === UDEU_BOUD_READY_STATUS || this.boudStatus === UDEU_BOUD_VALIDATED_STATUS,
        form: {
          group: this.infoFormGroup
        }
      },
      [CONTENT_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.CONTENT.TITLE",
        type: StepTypes.FILES,
        form: {
          group: this.contentsFormGroup,
          fields: {
            [SPANISH_CONTENT_FIELD]: {
              type: MatFormFieldType.INPUT_LANGUAGE
            },
            [EUSKERA_CONTENT_FIELD]: {
              type: MatFormFieldType.INPUT_LANGUAGE
            },
            [ENGLISH_CONTENT_FIELD]: {
              type: MatFormFieldType.INPUT_LANGUAGE
            }
          }
        }
      },
      [ELEMENTS_STEP]: {
        name: "DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.STEPS.ELEMENTS.TITLE",
        type: StepTypes.DOCS_TO_TRANSFER,
        form: {
          group: this.elementsFormGroup,
          fields: {
            [MENTIONED_ELEMENTS_FIELD]: {},
            [CORRECTED_ELEMENTS_FIELD]: {},
            [MODIFIED_ELEMENTS_FIELD]: {},
            [SUSPENDED_ELEMENTS_FIELD]: {},
            [REPEALED_ELEMENTS_FIELD]: {},
            [MENTIONERS_ELEMENTS_FIELD]: {},
            [MODIFIERS_ELEMENTS_FIELD]: {},
            [REPEALERS_ELEMENTS_FIELD]: {},
            [SUSPENDERS_ELEMENTS_FIELD]: {},
            [CORRECTORS_ELEMENTS_FIELD]: {}
          }
        }
      },
    }
  }

  updateActionType(option: KeyValue<string, string>) {
    this.actionType = option?.key;
    
    if(this.steps && this.steps[MAIN_DATA_STEP].form.fields)
      this.steps[MAIN_DATA_STEP].form.fields[PARTIAL_REPEAL_FIELD].disabled = this.actionType !== UDEU_BOUD_PARTIAL_REPEALING_ACTION;
    
    if(this.steps && this.elementsFormGroup){
      this.updateCorrectionValidators();
    }
  }

  updateType(option: KeyValue<string, string>) {
    this.boudType = option?.key;
    this.isPolicy = this.boudType ? UDEU_BOUD_POLICY_TYPES.includes(this.boudType) : null;

    // Fields
    if(this.steps && this.boudType) {
      // Effective date
      const effectiveDate = this.steps[MAIN_DATA_STEP].form.fields[EFFECTIVE_DATE_FIELD];
      effectiveDate.disabled = this.boudType && !this.isPolicy;
      
      this.updatePolicyValidators(PRIMARY_APPROVING_BODY_FIELD);
      this.updatePolicyValidators(PROVISION_NUMBER_FIELD);
    }

    // Content fields
    this.editableContentFields = this.isPolicy ? ['name', 'title'] : ['name'];
    this.mandatoryContentFields = this.isPolicy ? ['title'] : [];
  }

  
  updateSubtype(option: KeyValue<string, string>) {
    let isUDDisposition:boolean | null = option?.key ? UDEU_BOUD_UD_DISPOSITION_TYPE === option?.key : null;
    
    // Content fields
    this.editableContentFields = isUDDisposition ? ['name', 'title'] : ['name'];
    this.mandatoryContentFields = isUDDisposition ? ['title'] : [];
  }

  updatePolicyValidators(fieldName: string, disabled?: boolean) {
    const control = this.dataFormGroup.get(fieldName);
    if (this.isPolicy) {
      control.addValidators(Validators.required);    
    } else {
      control.removeValidators(Validators.required);
      this.isPolicy !== null && disabled ? control.reset() : null;
    }
    control.updateValueAndValidity();
  }

  updateCorrectionValidators() {
    const control = this.elementsFormGroup?.get(CORRECTED_ELEMENTS_FIELD);
    if (this.actionType == actionTypeEnum.UDEU_BOUD_CORRECTION_ACTION_TYPE) {
      control.setValidators(ArrayValidators.required);    
    } else {
      control.removeValidators(ArrayValidators.required);
    }
    control.updateValueAndValidity();
  }

  getList(stepId: string, fieldName: string, dataListName: string, parentKey?: string, reset?: boolean, needParentKey: boolean = true): Promise<any[]> {
    return this.data?.boudActionType === BoudActionTypes.ViewBoud ? null :
    this.udeuService.getList(this.steps, stepId, fieldName, dataListName, parentKey, reset, needParentKey, true);
  }
  
  getListFromMasterKeyAndValidators(stepId: string, fieldName: string, dataListName: string, masterKey?: string, reset?: boolean, needMasterKey: boolean = true){
    this.udeuService.getListFromMasterKey(this.steps, stepId, fieldName, dataListName, masterKey, reset, needMasterKey, true, needMasterKey).then((options) => {
      const control = this.steps[stepId].form.group.get(fieldName);
      if (options?.length > 0) {
        control.addValidators(Validators.required);
      } else {
        control.removeValidators(Validators.required);
      }
      control.updateValueAndValidity();
    });
  }
  
  getListAndValidators(stepId: string, fieldName: string, dataListName: string, parentKey?: string, reset?: boolean, needParentKey: boolean = true) {
    this.getList(stepId, fieldName, dataListName, parentKey, reset, needParentKey).then((options) => {
      const control = this.steps[stepId].form.group.get(fieldName);
      if (options?.length > 0) {
        control.addValidators(Validators.required);
      } else {
        control.removeValidators(Validators.required);
      }
      control.updateValueAndValidity();
    })
  }

  createBoud(save: boolean = false) {
    const fileSizeLimit = this.aldenService.getAppConfigProp(APP_CONFIG_FILE_SIZE_LIMIT);
    if(this.contentsFormGroup.invalid && (
      this.contentsFormGroup.controls[SPANISH_CONTENT_FIELD].hasError('maxSize') 
      || this.contentsFormGroup.controls[EUSKERA_CONTENT_FIELD].hasError('maxSize') 
      || this.contentsFormGroup.controls[ENGLISH_CONTENT_FIELD].hasError('maxSize'))) {
      this.store.dispatch(new SnackbarWarningAction('ALDEN.MESSAGES.ERRORS.FILE_SIZE_LIMIT', { fileSizeLimit }));
      return;
    } else {
      const attachedFilesArray = this.contentsFormGroup.value;
      let totalBytes = 0;
      for (const key in attachedFilesArray) {
        const array: AttachedFile[] = attachedFilesArray[key];
        for (let i = 0; i < array.length; i++) {
          totalBytes += array[i].size;
        }
      }
      const totalMB = totalBytes / (1024 * 1024);
      if(totalMB > fileSizeLimit) {
        this.store.dispatch(new SnackbarWarningAction('ALDEN.MESSAGES.ERRORS.FILE_SIZE_LIMIT', { fileSizeLimit }));
        return;
      }
    }

    const actionType = this.data.boudActionType;
    const isCreateAction = actionType === BoudActionTypes.CreateBoud;
    const isEditAction = actionType === BoudActionTypes.EditBoud;

    const udeuCreateBoud = new UdeuCreateBoud();
    const udeuBoud = new UdeuBoud();

    udeuBoud.status = new UdeuStatus(save ? (isEditAction ? this.boudStatus : UDEU_BOUD_DRAFT_STATUS) : UDEU_BOUD_READY_STATUS);
    udeuBoud.data = this.createData();
    udeuBoud.info = this.createInfo();
    udeuBoud.elements = this.createElements();
    udeuBoud.content = this.createContent(udeuCreateBoud);
    udeuCreateBoud.data = udeuBoud;
    
    if (isCreateAction || isEditAction) {
        const actionKey = isCreateAction ? "CREATE" : "EDIT";

        const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
          data: { 
            title: `DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.${actionKey}.DIALOG.TITLE`,
            message: `DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.${actionKey}.DIALOG.MESSAGE`,
            noLabel: `DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.${actionKey}.DIALOG.NO_LABEL`,
            yesLabel: `DEUSTO.NEW_MENU.MENU_ITEMS.BOUD.ACTIONS.${actionKey}.DIALOG.YES_LABEL`
          },
          minWidth: '250px'
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result) {   
            const loadingRef = this.dialog.open(SMTLoadingDialogComponent, {
              data: {
                title: 'Cargando...',
              },
              minWidth: '250px'
            });

            const action = isCreateAction 
              ? this.boudService.createBoud(udeuCreateBoud) 
              : this.boudService.updateBoud(this.data.UUID, udeuCreateBoud);

            action.then(() => {
              this.dialogRef.close();
              const route = '/viewer/boud';
              this.router.url === route 
                ? this.store.dispatch(new ReloadCustomListTableAction(false)) 
                : this.router.navigate([route]);
            }).catch((err) => {
              console.error("ERROR", err);
              this.store.dispatch(new SnackbarErrorAction('Hubo un error inesperado. Contacte con el administrador.'));
            }).finally(() => {
              loadingRef.close();
            });
          }
        });
    }
  }

  createData(): UdeuData {
    const data = new UdeuData();
    data.type = (this.dataFormGroup.get(TYPE_FIELD).value as KeyValue<string,string>)?.key;
    data.subtype = (this.dataFormGroup.get(SUBTYPE_FIELD).value as KeyValue<string,string>)?.key;
    const primaryApprovingBody = (this.dataFormGroup.get(PRIMARY_APPROVING_BODY_FIELD).value as KeyValue<string,string>[]);
    data.primaryApprovingBody = primaryApprovingBody?.length > 0 ? primaryApprovingBody.map((opt) => opt.key) : [];
    const nominalSubdivision = (this.dataFormGroup.get(NOMINAL_SUBDIVISION_FIELD).value as KeyValue<string,string>[]);
    data.nominalSubdivision = nominalSubdivision?.length > 0 ? nominalSubdivision.map((opt) => opt.key) : [];
   // const secondaryApprovingBody = (this.dataFormGroup.get(SECONDARY_APPROVING_BODY_FIELD).value as KeyValue<string,string>[]);
   // data.secondaryApprovingBody = secondaryApprovingBody?.length > 0 ? secondaryApprovingBody.map((opt) => opt.key) : [];
   // const secondaryApprovingBodySub = (this.dataFormGroup.get(SECONDARY_APPROVING_BODY_SUB_FIELD).value as KeyValue<string,string>[]);
   // data.secondaryApprovingBodySub = secondaryApprovingBodySub?.length > 0 ? secondaryApprovingBodySub.map((opt) => opt.key) : [];
    data.provisionNumber = this.dataFormGroup.get(PROVISION_NUMBER_FIELD).value;
    data.actionType = (this.dataFormGroup.get(ACTION_TYPE_FIELD).value as KeyValue<string,string>)?.key;
    data.approvalDate = this.dataFormGroup.get(APPROVAL_DATE_FIELD).value;
    data.effectiveDate = this.dataFormGroup.get(EFFECTIVE_DATE_FIELD).value;
    data.observations = this.dataFormGroup.get(OBSERVATIONS_FIELD)?.value
    data.partialRepeal = this.dataFormGroup.get(PARTIAL_REPEAL_FIELD)?.value;
    return data;
  }

  createInfo(): UdeuInfo {
    const info = new UdeuInfo();
    info.publicationDate = this.dataFormGroup.get(PUBLICATION_DATE_FIELD)?.value;
    info.publicationUser = this.dataFormGroup.get(PUBLICATION_USER_FIELD)?.value;
    return info;
  }

  createElements() : AssocElements {
    const elements = new AssocElements();

    const mentionedElements = (this.elementsFormGroup.get(MENTIONED_ELEMENTS_FIELD).getRawValue() as UdeuBoud[])
    elements.mentionedElements = mentionedElements ? mentionedElements.map((boud) => boud.id) : [];

    const modifiedElements = (this.elementsFormGroup.get(MODIFIED_ELEMENTS_FIELD).getRawValue() as UdeuBoud[]);
    elements.modifiedElements = modifiedElements ? modifiedElements.map((boud) => boud.id) : [];
    
    const suspendedElements = (this.elementsFormGroup.get(SUSPENDED_ELEMENTS_FIELD).getRawValue() as UdeuBoud[]);
    elements.suspendedElements = suspendedElements ? suspendedElements.map((boud) => boud.id) : [];

    const repealedElements = (this.elementsFormGroup.get(REPEALED_ELEMENTS_FIELD).getRawValue() as UdeuBoud[]);
    elements.repealedElements = repealedElements ? repealedElements.map((boud) => boud.id) : [];

    const correctedElements = (this.elementsFormGroup.get(CORRECTED_ELEMENTS_FIELD).getRawValue() as UdeuBoud[]);
    elements.correctedElements = correctedElements ? correctedElements.map((boud) => boud.id) : [];

    return elements;
  }

  createContent(udeuCreateBoud: UdeuCreateBoud): UdeuContent {
    const content = new UdeuContent();
    udeuCreateBoud.files = [];
    
    content.spanishContent = this.createContentFile(SPANISH_CONTENT_FIELD, udeuCreateBoud);
    content.euskeraContent = this.createContentFile(EUSKERA_CONTENT_FIELD, udeuCreateBoud);
    content.englishContent = this.createContentFile(ENGLISH_CONTENT_FIELD, udeuCreateBoud);

    return content;
  }

  private createContentFile(field: string, udeuCreateBoud: UdeuCreateBoud) {
    let files = this.contentsFormGroup.get(field).value as AttachedFile[];
    if(files?.length > 0) { 
      const file = files[0];
      if(!file.uuid) {
        const udeuCreateFile: UdeuCreateFile = { id: file.fileId, file: file.file };
        udeuCreateBoud.files.push(udeuCreateFile);
      }
      return new UdeuFile(file.uuid, file.fileId, file.name, file.title, file.description);
    }
    return undefined;
  }

  isCompleted(matStep: MatStep) {
    const transferActionType = this.data?.boudActionType ?? BoudActionTypes.CreateBoud;
    switch (transferActionType) {
      case BoudActionTypes.CreateBoud:
        return !matStep.stepControl.invalid && matStep.interacted;
      case BoudActionTypes.EditBoud:
        return !matStep.stepControl.invalid;
      default:
        return false;
    }
  }

  getGaudeList(stepId: string, fieldName: string, dataListName: string, reset?:boolean, value?: string): Promise<any[]> {
      return this.udeuService.getGaudeList(this.steps, stepId, fieldName, dataListName, value,reset);
    }
    
   getActiveProducingBodiesList(stepId: string, fieldName: string, reset?:boolean): Promise<any[]> {
      return this.udeuService.getActiveProducingBodiesList(this.steps, stepId, fieldName,reset);
    }
}
